import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { WorkOrderDetails, LockerDetail } from 'projects/Administration/src/app/business-entities/auto-key-model';
import { SelectListItemViewModel } from 'projects/Administration/src/app/business-entities/select-list-item-view-model';
import { AutoKeyBusinessService } from 'projects/Administration/src/app/business-services/auto-key.service';
import { DealerServiceBusinessService } from 'projects/Administration/src/app/business-services/dealer-service.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { Application } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';

@Component({
  selector: 'app-add-auto-key',
  templateUrl: './add-auto-key.component.html',
  styleUrls: ['./add-auto-key.component.css']
})
export class AddAutoKeyComponent implements OnInit {
  lockerId: string;
  appointmentId: number;
  finalInvoiceAmount: any;
  isShareboxPaymentMethod: boolean;
  closeResult: string;
  workOrderDetails: WorkOrderDetails[];
  dealerList: Array<SelectListItemViewModel>;
  selectedDealerId: string = '';
  dealerSelected: string = '';
  paginationSub: Subscription;
  keyLockerDetails: LockerDetail[] = [];
  selectedtab: number = 1;
  modalReference: any;
  selectedLocker: LockerDetail;

  constructor(
    private dealerServiceBusinessService: DealerServiceBusinessService,
    private service: AutoKeyBusinessService,
    private modalService: NgbModal,
    public pService: CustomPaggerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private userService: UserDataService,
    private activeModal: NgbActiveModal
  ) {
    this.pService.searchby = ['licensePlate', 'workorderNo'];
    this.pService.searchTerm = '';
  }

  ngOnInit(): void {
    this.dealerList = this.service.dealerList;
    this.dealerServiceBusinessService.dealerId = this.userService.currentUserValue.dealerId;
    if(this.dealerList.length === 1){
      this.dealerSelected = this.dealerList[0].value;
      this.getLockerList(this.dealerSelected)
    }
  }

  setDealerId(dealerId: string) {
    this.selectedDealerId = dealerId;
    this.dealerServiceBusinessService.dealerId = this.selectedDealerId ? this.selectedDealerId : '';
  }

  getLockerList(dealerId: string) {
    this.spinner.show();
      this.service.getAvailableLockers(dealerId).then(res => {
        if (res.responseObject.length !== undefined){ 
          this.keyLockerDetails = res.responseObject; 
        }
        else{ 
          this.keyLockerDetails = [];
        }
        this.spinner.hide();
      }) 
  }

  onDealerSelected(dealerId: string) {
    this.dealerSelected = dealerId ? this.dealerList.find(x => x.value === dealerId)?.text : '';
    this.setDealerId(dealerId ? dealerId : '');
    this.getLockerList(dealerId ? dealerId : '');
  }

  openLocker(content, locker: LockerDetail) {
    this.selectedLocker = locker;
    let viewModel = {
      DealerId: this.selectedDealerId,
      Date: new Date()
    }
    this.getWorkOrderDeatils(viewModel);
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
    this.modalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  getWorkOrderDeatils(model: any) {
    this.service.getWorkOrderDetails(model).then(
      res => {
        if (res.responseObject.length !== undefined) {
          this.pService.dataSource = res.responseObject;
          this.paginationSub = this.pService.dealers$.subscribe(result => {
            this.workOrderDetails = result;
          });
        }
        else {
          this.workOrderDetails = [];
        }
      }
    )
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  findObject(object: any) {
    this.appointmentId = object.appointmentId
  }

  setSelectedAppointmentDetails($event) {
    this.appointmentId = $event.appointmentId
    this.finalInvoiceAmount = $event.finalInvoiceAmount
    this.isShareboxPaymentMethod = $event.isShareboxPaymentMethod
  }

  AssignLocker() {
    if (this.selectedtab === 1 && this.appointmentId > 0) {
      this.spinner.show();
      let viewModel =
      {
        ReservationId : this.selectedLocker.reservationId,
        SubscriptionId : this.selectedLocker.subscriptionId,
        LockerNo : this.selectedLocker.lockerNo,
        Location : this.selectedLocker.location ,
        LocationId : this.selectedLocker.locationId,
        AppointmentId: this.appointmentId,
        User: this.userService.currentUserValue.id,
        ApplicationId: Application.Admin,
        IsShareboxPaymentMethod: this.isShareboxPaymentMethod,
        FinalInvoiceAmount: this.finalInvoiceAmount
      };
      this.service.reserveLocker(viewModel).then(res => {
        if (res.responseObject) {
          let success = this.translate.instant("lblAssignKey");
          this.toastr.success(success);
          document.getElementById("modelButton").click();
          this.getLockerList(this.dealerServiceBusinessService.dealerId);
        }
        else {
          let error = this.translate.instant("lblNotAssign");
          this.toastr.error(error);
        }
      })
      this.spinner.hide();
    }
  }
  OnClose() {
    this.activeModal.close({ success: true });
  }
}
